const DAVINCI = 'davinci';
const HBUS_READY_EVENT = 'hbus:ready';

let queuedRequestContexts = [];

function queueRequest(eventName, eventData) {
  queuedRequestContexts.push(
    {
      eventName,
      eventData,
    }
  );
}

function triggerQueuedEvents() {
  if (queuedRequestContexts) {
    queuedRequestContexts.forEach(
      ({eventName, eventData}) => {
        trackEvent(eventName, eventData);
      }
    );
  }
}

function trackEvent(eventName, eventData) {
  window['hepsiBus'].send(DAVINCI, eventName, eventData);
}

const hbusApiClient = {
  sendEventRequest(eventName, eventData) {
    return new Promise((resolve, reject) => {
      if (window['hepsiBus']) {
        trackEvent(eventName, eventData);
      } else {
        queueRequest(eventName, eventData);
      }

      resolve({data: {}});
    });
  },
};

if (window.addEventListener) {
  window.addEventListener(
    HBUS_READY_EVENT,
    function () {
      if (window['hepsiBus']) {
        triggerQueuedEvents();
      } else {
        queuedRequestContexts = null;
      }
    }
  );
}

export default hbusApiClient;



// WEBPACK FOOTER //
// ./src/app/analytics/hbusApiClient.ts